import { render, staticRenderFns } from "./TrainerBag.vue?vue&type=template&id=80ab4b82&scoped=true"
import script from "./TrainerBag.vue?vue&type=script&lang=js"
export * from "./TrainerBag.vue?vue&type=script&lang=js"
import style0 from "./TrainerBag.vue?vue&type=style&index=0&id=80ab4b82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ab4b82",
  null
  
)

export default component.exports